<template>
  <div class="yhc-component 改成文件名字一样">
    <h1>1</h1>
  </div>
</template>

<script>
// import module from './module'

export default {
  components: {},
  mixins: [],
  data() {
    return {};
  },
  props: {},
  computed: {},
  watch: {},
  methods: {},
  beforeCreate() {},
  created() {},
  mounted() {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.改成文件名字一样 {
}
</style>
